import React, { createContext, useContext, useReducer } from "react";
import { UserDataContext } from "./UserDataContext";
import { MenuItem, InputAdornment } from "@material-ui/core";
import { roles } from "../Mappings";
import { LinehaulDataReducer } from "../Reducers/LinehaulDataReducer";
import { statuses } from "../Mappings";
import { getWeekDates } from "../GlobalFunctions";

export const LinehaulFixedDataContext = createContext();

const LinehaulFixedDataContextProvider = (props) => {
  const { userData } = useContext(UserDataContext);
  const [linehaulFixedData, dispatch] = useReducer(LinehaulDataReducer, {});

  console.log("Rerender");

  const getActiveRoutesIdArray = (truck, week) => {
    const { startDate, endDate } = getWeekDates(week);
    const routesIdArray = getRoutesIdArray();
    const activeRoutesIdArray = routesIdArray.filter((id) => {
      const routeObj = getRouteObjectFromId(id);
      if (routeObj.truckId !== truck) {
        return false;
      }

      const routeStartDate = new Date(routeObj.startDate);
      const routeEndDate = new Date(routeObj.endDate);

      // console.log(startDate.toISOString());
      // console.log(endDate.toISOString());
      // console.log(routeStartDate.toISOString());
      // console.log(routeEndDate.toISOString());
      // console.log("-------------");

      // check if there is any overlap
      // if no endDate for route
      if (!routeObj.endDate && routeStartDate < endDate) {
        return true;
      } else if (startDate <= routeEndDate && endDate >= routeStartDate) {
        return true;
      }
      return false;
    });

    return activeRoutesIdArray;
  };

  const getRoutesIdArray = (truckId) => {
    return userData.routes.map((route) => route.id);
  };

  const getRouteObjectFromId = (id) => {
    const [route] = userData.routes.filter((route) => route.id === id);
    const idArray = [...Array(11).keys()].slice(1);
    const accountCodeKeys = idArray.map((n) => `accountCode${n}`);
    const costCentreKeys = idArray.map((n) => `costCentre${n}`);
    const percentageKeys = idArray.map((n) => `percentage${n}`);
    const obj = {
      routeName: route.routeName,
      routeRate: route.routeRate,
      routeFaf: route.faf,
      accountCodes: accountCodeKeys.map((key) => route[key]).filter((e) => e), // filter to remove empty ones
      costCentres: costCentreKeys.map((key) => route[key]).filter((e) => e),
      percentages: percentageKeys.map((key) => route[key]).filter((e) => e),
      startDate: route.startDate,
      endDate: route.endDate,
    };
    return obj;
  };

  const buildRoutesObjFromRoutesIdArray = (arr) =>
    arr.reduce((acc, id) => {
      acc[id] = getRouteObjectFromId(id);
      return acc;
    }, {});

  const routesObj = buildRoutesObjFromRoutesIdArray(getRoutesIdArray());
  const getActiveRoutesObj = (truck, week) =>
    buildRoutesObjFromRoutesIdArray(getActiveRoutesIdArray(truck, week));

  const truckRoutesObj = userData.trucks.reduce((acc, cur) => {
    acc[cur.truckId] = cur.routes.reduce((truckRouteObj, route) => {
      truckRouteObj[route.id] = getRouteObjectFromId(route.id);
      return truckRouteObj;
    }, {});
    return acc;
  }, {});

  // console.log(truckRoutesObj);

  const alphabeticalComparator = (a, b) => {
    const s1 = routesObj[a].routeName;
    const s2 = routesObj[b].routeName;
    if (s1 < s2) return -1;
    if (s1 > s2) return 1;
    return 0;
  };

  const linehaulFixedModel = {
    routeId: {
      displayName: "Route",
      displayValue: (value) => routesObj[value].routeName,
      validate: (allValues) => allValues.routeId !== "",
      mapToRequestValue: (value) => Number(value),
      getChildren: (truckId, week) => {
        return Object.keys(truckRoutesObj[truckId])
          .filter((routeId) => {
            const { startDate: weekStartDate } = getWeekDates(week);
            const routeStartDate = new Date(
              truckRoutesObj[truckId][routeId].startDate
            );
            console.log(truckRoutesObj[truckId][routeId].startDate);
            console.log(routeStartDate, weekStartDate);
            if (!truckRoutesObj[truckId][routeId].endDate) {
              if (routeStartDate <= weekStartDate) {
                return true;
              }
            } else {
              const routeEndDate = new Date(routesObj[routeId].endDate);
              if (
                routeStartDate <= weekStartDate &&
                weekStartDate <= routeEndDate
              ) {
                return true;
              }
            }
            return false;
          })
          .sort(alphabeticalComparator)
          .map((routeId) => (
            <MenuItem key={routeId} value={routeId}>
              {routesObj[routeId].routeName}
            </MenuItem>
          ));
      },
      textFieldProps: {
        name: "routeId",
        select: true,
        // children: Object.keys(routesObj)
        //   .sort(alphabeticalComparator)
        //   .map((routeId) => (
        //     <MenuItem key={routeId} value={routeId}>
        //       {routesObj[routeId].routeName}
        //     </MenuItem>
        //   )),
      },
    },
    adjustment: {
      displayName: "Adjustment",
      displayValue: (value) => `$${(Math.round(value * 100) / 100).toFixed(2)}`,
      validate: (allValues) =>
        /^-?\d+(\.\d{1,2})?$/.test(allValues.adjustment) ||
        allValues.adjustment === "",
      mapToRequestValue: (value) => Number(value),
      textFieldProps: {
        name: "adjustment",
        InputProps: { startAdornment: <InputAdornment>$</InputAdornment> },
      },
    },
    tripCost: {
      displayName: "Trip Cost",
      displayValue: (value) => `$${(Math.round(value * 100) / 100).toFixed(2)}`,
      validate: (allValues) => allValues.tripCost !== "",
      mapToRequestValue: (value) => Number(value),
      textFieldProps: {
        name: "tripCost",
        disabled: true,
        InputProps: { startAdornment: <InputAdornment>$</InputAdornment> },
        // variant: "outlined",
      },
    },
    totalCost: {
      displayName: "Total Cost",
      displayValue: (value) => `$${(Math.round(value * 100) / 100).toFixed(2)}`,
      validate: (allValues) => allValues.totalCost !== "",
      mapToRequestValue: (value) => Number(value),
      textFieldProps: {
        name: "totalCost",
        disabled: true,
        InputProps: { startAdornment: <InputAdornment>$</InputAdornment> },
        variant: "outlined",
      },
    },
    driverComments: {
      displayName: "Driver Comments",
      displayValue: (value) => value,
      validate: (allValues) =>
        allValues.adjustment === "" ? true : allValues.driverComments !== "",
      mapToRequestValue: (value) => value,
      textFieldProps: {
        name: "driverComments",
        placeholder: "Provide a brief description",
        multiline: true,
        variant: "outlined",
        rows: 3,
        rowsMax: 3,
      },
    },
    adminComments: {
      displayName: "Admin Comments",
      displayValue: (value) => value,
      validate: (allValues) =>
        allValues.adjustment === "" ? true : allValues.adminComments !== "",
      mapToRequestValue: (value) => value,
      textFieldProps: {
        name: "adminComments",
        placeholder: "Provide a brief description",
        multiline: true,
        variant: "outlined",
        rows: 3,
        rowsMax: 3,
      },
    },
    managerComments: {
      displayName: "Manager Comments",
      displayValue: (value) => value,
      validate: (allValues) =>
        allValues.adjustment === "" ? true : allValues.managerComments !== "",
      mapToRequestValue: (value) => value,
      textFieldProps: {
        name: "managerComments",
        placeholder: "Provide a brief description",
        multiline: true,
        variant: "outlined",
        rows: 3,
        rowsMax: 3,
      },
    },
    approvalState: {
      displayName: "Approval State",
      displayValue: (value) => statuses[value],
      validate: (allValues) => true,
      mapToRequestValue: (value) => value,
      textFieldProps: {
        name: "approvalState",
      },
    },
  };

  const fixedColumns = ["routeId", "adjustment", "tripCost", "totalCost"];

  const comments = {
    [roles.tollAdmin]: "adminComments",
    [roles.ownerDriver]: "driverComments",
    [roles.tollManager]: "managerComments",
  }[userData.roleId];

  const defaultFixed = {
    id: "",
    driverId: "",
    eventDateTime: "",
    routeId: "",
    adjustment: "",
    driverComments: "",
    adminComments: "",
    managerComments: "",
  };

  return (
    <LinehaulFixedDataContext.Provider
      value={{
        linehaulFixedModel,
        fixedColumns,
        defaultFixed,
        routesObj,
        getRouteObjectFromId,
        linehaulFixedData,
        dispatch,
        comments,
        getActiveRoutesObj,
      }}
    >
      {props.children}
    </LinehaulFixedDataContext.Provider>
  );
};

export default LinehaulFixedDataContextProvider;
